module.exports = __webpack_public_path__ + "img/kadoorieMain.efc3578e.png";